import React, { Component } from 'react'
import CreatePose from './CreatePose'

// should add a button to display all the pose (PoseList)

export default class AdminDashboard extends Component {
  render() {
    return (
      <div>
        <CreatePose />
      </div>
    )
  }
}
